var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('busy-button',{staticClass:"w-44",attrs:{"variant":_vm.variant,"id":_vm.templateSaveButtonId,"is-loading":_vm.isBusy,"is-disabled":_vm.isEmptyStateTree || _vm.isDisabled},on:{"click":_vm.saveTemplate}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }